import {
  mainOptionsLabels as labels,
  mainOptionsValues as values,
} from '../helper'

import {
  RETAIL_PRICE as RETAIL_PRICE_LABEL,
  ZEN_PRICE as ZEN_PRICE_LABEL,
  CLIENT_PRICE as CLIENT_PRICE_LABEL,
} from '../../../DialogPriceBulkUpload/helper'

export const PRICE_ZEN_VALUE = 'price_zen'
export const PRICE_RETAIL_VALUE = 'price_retail'
export const PRICE_CLIENT_PRACTICE_VALUE = 'price_client_practice_location'

export const PHONE_NUMBER_AS_ACCOUNT_NUMBER_LABEL =
  'Phone number as Account Number'
export const PHONE_NUMBER_AS_ACCOUNT_NUMBER_VALUE = 'phoneNumber'

export const priceTypesList = [
  PRICE_ZEN_VALUE,
  PRICE_RETAIL_VALUE,
  PRICE_CLIENT_PRACTICE_VALUE,
]

export const accountNumberList = [
  {
    label: labels.cxml,
    value: values.cxml,
  },
  {
    label: labels.script,
    value: values.script,
  },
  {
    label: labels.vendorPortal,
    value: values.vendorPortal,
  },
  {
    label: labels.zenRep,
    value: values.zenRep,
  },
  {
    label: PHONE_NUMBER_AS_ACCOUNT_NUMBER_LABEL,
    value: PHONE_NUMBER_AS_ACCOUNT_NUMBER_VALUE,
  },
]

export const accountHistoryList = [
  {
    label: labels.script,
    value: values.script,
  },
  {
    label: labels.vendorPortal,
    value: values.vendorPortal,
  },
  {
    label: labels.zenRep,
    value: values.zenRep,
  },
]

export const productStatusList = [
  {
    label: labels.cxml,
    value: values.cxml,
  },
  {
    label: labels.script,
    value: values.script,
  },
  {
    label: labels.vendorPortal,
    value: values.vendorPortal,
  },
  {
    label: labels.zenRep,
    value: values.zenRep,
  },
]

export const managePriceList = [
  {
    label: labels.cxml,
    value: values.cxml,
  },
  {
    label: labels.script,
    value: values.script,
  },
  {
    label: labels.vendorPortal,
    value: values.vendorPortal,
  },
  {
    label: labels.zenRep,
    value: values.zenRep,
  },
]

export const customerIdList = [
  {
    label: labels.cxml,
    value: values.cxml,
  },
  {
    label: labels.vendorPortal,
    value: values.vendorPortal,
  },
  {
    label: labels.script,
    value: values.script,
  },
]

export const priceTypeList = [
  {
    id: 1,
    label: ZEN_PRICE_LABEL,
    value: PRICE_ZEN_VALUE,
    tooltip:
      'ZenPrice is a special price provided for Zen Members only and offers great savings.',
  },
  {
    id: 2,
    label: RETAIL_PRICE_LABEL,
    value: PRICE_RETAIL_VALUE,
    tooltip:
      'Retail price is a distributor price or online price that any Zen Member can see.',
  },
  {
    id: 3,
    label: CLIENT_PRICE_LABEL,
    value: PRICE_CLIENT_PRACTICE_VALUE,
    tooltip:
      'Client Price is a special price for a selected dental practice. Our system will allow you to assign client price for each practice individually. ',
  },
]
